export default __webpack_public_path__ + "static/media/userTieIcon.22565848.svg";